import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { FC, ReactElement } from "react";

const Container = styled("div")<{ $width?: number }>(({ $width }) => ({
  width: $width ? `${$width}px` : "auto",
}));

const RequestsItemLayout: FC<any> = ({
  width,
  title,
  fontWeight = "normal",
  color = "primary",
}: any): ReactElement => {
  return (
    <Container $width={width}>
      <Typography fontWeight={fontWeight} color={color}>
        {title}
      </Typography>
    </Container>
  );
};

export default RequestsItemLayout;
